import { motion } from 'framer-motion'
import './Benefits.css'

export default function Benefits() {
    const benefits = [
        {
            title: 'Atomic Settlement',
            description: 'Settlements achieve finality in sub-second timeframes with our optimized protocol infrastructure',
            icon: '⚡'
        },
        {
            title: 'High Privacy',
            description: 'No accounts required. Connect your wallet and execute settlements with non-custodial architecture',
            icon: '🔒'
        },
        {
            title: 'Blockchain-Verified',
            description: 'Every settlement is cryptographically verified and recorded on-chain',
            icon: '✓'
        },
        {
            title: 'Multi-Chain Ready',
            description: 'Support for TRC20, ERC20, TON, and more chains coming soon',
            icon: '🔗'
        },
        {
            title: 'High Throughput',
            description: 'Optimized network routing ensures sub-200ms propagation delay and maximum settlement velocity',
            icon: '🚀'
        },
        {
            title: 'Non-Custodial',
            description: 'You maintain full control of your funds. We never hold your private keys',
            icon: '🛡️'
        }
    ]

    return (
        <section className="benefits-section">
            <div className="container">
                <motion.div
                    className="section-header"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <h2 className="section-title">
                        Why Choose <span className="text-neon">TetherStream Protocol</span>?
                    </h2>
                    <p className="section-subtitle">
                        Unmatched throughput, privacy, and reliability in every settlement.
                    </p>
                </motion.div>

                <div className="benefits-grid">
                    {benefits.map((benefit, index) => (
                        <motion.div
                            key={index}
                            className="benefit-module glass"
                            initial={{ opacity: 0, x: index % 2 === 0 ? -30 : 30 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.6, delay: index * 0.1 }}
                        >
                            <div className="benefit-icon-wrapper">
                                <span className="benefit-icon">{benefit.icon}</span>
                                <div className="icon-ring"></div>
                            </div>
                            <div className="benefit-content">
                                <h3 className="benefit-title">{benefit.title}</h3>
                                <p className="benefit-description">{benefit.description}</p>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    )
}
